module.exports = __webpack_public_path__ + "static-portal/img/al-3.9841b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/al-3.jpg
// module id = OxUu
// module chunks = 4